<template>
  <a-modal
    :title="'导入设备'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="editForm"
      :model="editForm"
      :rules="editFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="上传文件" prop="storeId">
        <a-upload
          name="file"
          :multiple="false"
          accept=".xlsx,.xls"
          :before-upload="beforeUpload"
        >
          <a-button> <a-icon type="upload" />上传</a-button>
        </a-upload>
      </a-form-model-item>
      <a-row :span="24">
        <a-col :offset="3">
          <p>导入文件请注意标明设备SN、设备类型、状态</p>
        </a-col>
      </a-row>
    </a-form-model>
    <a-card>
      <a-table
        :columns="tableColumn"
        :dataSource=" sourceList"
      >
      </a-table>
    </a-card>
  </a-modal>
</template>

<script>
import store from '@/store'
import * as XLSX from 'xlsx'

const enumsData = store.state.enumsStore.enumsData
const { deviceType: deviceTypes  } = enumsData

const editForm = {
  deviceId: undefined,
  storeId: undefined,
}
const editFormRules = {}


export default {
  name: 'ImportModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      editForm,
      editFormRules,
      deviceTypes: deviceTypes,
      headers: {
        authorization: 'authorization-text',
      },
      sourceList:[],
      tableColumn: [
        {title: '设备SN',dataIndex: 'sn'},
        {title: '设备类型',dataIndex: 'deviceTypeName'},
        {title: '设备状态',dataIndex: 'state',scopedSlots: { customRender: 'state' }},
      ],
      uploading: false,
      confirmLoading:false
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          const { id } = this.obj
          this.editForm = { deviceId: id, storeId: undefined }
        })
      }
    }
  },
  created() {},
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', {data: this.sourceList})
          this.confirmLoading = true
        }
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.editForm.resetFields()
      this.editForm = editForm
      this.confirmLoading = false
    },

    beforeUpload(file) {
      let _this = this
      let sourceData = _this.sourceList = []
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        for (let i = 0; i <jsonData.length ; i++) {
          const source = jsonData[i]
          let param = {sn:source["设备SN"] || source["SN"], deviceTypeName: source["设备类型"], state: source["设备状态"]}
          param.deviceType = _this.queryDeviceType(_this, param.deviceTypeName)
          sourceData.push(param)
        }
        _this.sourceList = sourceData
      };
      reader.readAsArrayBuffer(file);
      return false; // 阻止自动上传
    },
    queryDeviceType(obj, name){
      const deviceTypes = enumsData.DeviceType
      console.log(deviceTypes)
      return deviceTypes.find(item => item.name === name).code
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
